import { GtmApiContext } from '@sleepstation/components-context'
import { useContext, useEffect } from 'react'
import { useLocation } from 'react-router'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const EVENT_NAME = `gatsby-route-change`

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const usePushRouteChangeToGtm = () => {
  const gtmApi = useContext(GtmApiContext)
  const { pathname } = useLocation()

  useEffect(() => {
    gtmApi.push(EVENT_NAME)
  }, [pathname, gtmApi])
}

export default usePushRouteChangeToGtm
